<template>
  <span class="badge">{{ text}}</span>
</template>

<script>
export default {
  props: ["text"]
}
</script>

<style lang='scss' scoped>
span.badge {
  background-color: #343434;
  color: white;
  border-radius: 16px;
  padding: 4px 12px;
  margin: 0 6px 4px 0;
  word-wrap: break-word;
  font-weight: normal;
  font-size: 16px;
}
</style>
